import SignUp from "components/SignUp/SignUp";
import React from "react";

const SignUpPage = () => {
    return (
        <>
            <SignUp />
        </>
    );
};

export default SignUpPage;